import { render, staticRenderFns } from "./WidgetDTE.vue?vue&type=template&id=2448bab8&lang=pug&"
import script from "./WidgetDTE.vue?vue&type=script&lang=js&"
export * from "./WidgetDTE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports